export default __webpack_public_path__ + "static/media/انضم إلينا.8c0700d0.jpg";